import React from "react";
import { Navigate } from "react-router-dom";
import { useUnit } from "effector-react";
import { $authStore } from "../../features/auth/store/auth";
import { ROUTES } from "../constants/app";
import { redirectUtils } from "../utils/redirectUtils";

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const authState = useUnit($authStore);

  // Safe extraction of authentication state
  const isAuthenticated = React.useMemo(() => {
    try {
      // Check multiple sources for authentication
      const storeAuth = Boolean(authState?.isAuthenticated);
      const tokenAuth = Boolean(localStorage.getItem("authToken"));

      // Return true only if both sources agree the user is authenticated
      return storeAuth && tokenAuth;
    } catch (error) {
      console.warn("PublicRoute authentication check error:", error);
      return false;
    }
  }, [authState]);

  // If user is authenticated, redirect to stored return URL or home
  if (isAuthenticated) {
    const returnUrl = redirectUtils.getAndClearReturnUrl();
    const redirectTo = returnUrl || ROUTES.HOME;
    //console.log('PublicRoute: Authenticated user redirecting to:', redirectTo);
    return <Navigate to={redirectTo} replace />;
  }

  // Otherwise, render the public route content
  return <>{children}</>;
};

export default PublicRoute;
